import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import Step from '../../components/Stepper/Step'

export const renderStep = props => ({ match }) => (
  <Step
    current={!!match}
    {...props}
  />
)

function RouteStep({
  path,
  exact,
  strict,
  location,
  sensitive,
  ...props
}) {
  return (
    <Route
      path={path}
      exact={exact}
      strict={strict}
      location={location}
      sensitive={sensitive}
      children={renderStep(props)}
    />
  )
}

RouteStep.propTypes = {
  path: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.sting),
    PropTypes.string
  ]).isRequired,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  location: PropTypes.object,
  sensitive: PropTypes.bool
}

export default RouteStep
